import React from "react";
import "./Play_Now_Game.css";
import WalletCard from "./WalletCard/WalletCard";
import GameTabs from "./GameTabs/GameTabs";
import TimerSection from "./TimerSection/TimerSection";
import Website_ugread from "../Common/Common_Component/Website_ugread/Website_ugread";
import Bet_Select_section from "./Bet_Select_section/Bet_Select_section";
import Inner_Header from "../Common/Common_Component/Inner_Header/Inner_Header";
import Game_tabs_Section from "./Game_tabs_Section/Game_tabs_Section";

function Play_Now_Game() {
  return (
    <div className="play_now_game">
      <Inner_Header />
      <section className="container">
        <div className="game_container">
          <WalletCard />
          <Website_ugread />
          <GameTabs />
          <TimerSection />
          <Bet_Select_section />
          <Game_tabs_Section/>
        </div>
      </section>
    </div>
  );
}

export default Play_Now_Game;
